import { type FC } from 'react';
import ArrowRight from 'dibs-icons/exports/legacy/ArrowRight.ts';

import styles from './arrow.scss';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    isLeft?: boolean;
};

export const Arrow: FC<Props> = ({ isLeft }) => (
    <span className={classnames(dibsCss.block, isLeft && styles.isLeft)}>
        <ArrowRight />
    </span>
);
